module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../images/shop_top.jpeg"),
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "store-form"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('section', {
    staticClass: "label bb clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.userName),
      expression: "formData.userName"
    }],
    attrs: {
      "type": "text",
      "id": "user_name",
      "maxlength": "15",
      "placeholder": "请输入参保商家法定代表人（或经营者）",
      "value": ""
    },
    domProps: {
      "value": (_vm.formData.userName)
    },
    on: {
      "focus": _vm.eidtName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "userName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "label bb clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.idCard),
      expression: "formData.idCard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.formData.idCard)
    },
    on: {
      "focus": _vm.eidtCard,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "idCard", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.formData.apInfoList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "wifi-body"
    }, [_c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "wifi-info"
    }, [_c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(3, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ssid),
        expression: "item.ssid"
      }],
      staticStyle: {
        "width": "220px"
      },
      attrs: {
        "type": "text",
        "placeholder": "手动输入WiFi热点名称"
      },
      domProps: {
        "value": (item.ssid)
      },
      on: {
        "focus": _vm.eidtSsid,
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ssid", $event.target.value)
        }, function($event) {
          return _vm.changeText(item.ssid, key)
        }]
      }
    }), _vm._v(" "), (!_vm.isIOS) ? _c('div', {
      staticClass: "select-wifi",
      on: {
        "click": function($event) {
          return _vm.selectWifi(key)
        }
      }
    }, [_vm._v("\n            选择附近WiFi\n            "), _c('img', {
      staticClass: "arrow-right",
      attrs: {
        "src": require("../assets/arrow-right.png")
      }
    })]) : _vm._e()]), _vm._v(" "), _c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(4, true), _vm._v(" "), _c('ul', {
      staticClass: "macList clearfix"
    }, _vm._l((item.bssidList), function(bssid, index) {
      return _c('li', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (bssid.title),
          expression: "bssid.title"
        }],
        attrs: {
          "type": "text",
          "maxlength": "1"
        },
        domProps: {
          "value": (bssid.title)
        },
        on: {
          "focus": _vm.eidtMac,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(bssid, "title", $event.target.value)
          }
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (bssid.title1),
          expression: "bssid.title1"
        }],
        attrs: {
          "type": "text",
          "maxlength": "1"
        },
        domProps: {
          "value": (bssid.title1)
        },
        on: {
          "focus": _vm.eidtMac,
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(bssid, "title1", $event.target.value)
          }
        }
      }), _vm._v(" "), (index !== (item.bssidList.length - 1)) ? _c('span', [_vm._v(":")]) : _vm._e()])
    }), 0), _vm._v(" "), _c('p', [_vm._v("MAC地址通常在路由器背面的铭牌上可以找到，由0-9之间的数字和a-f之间的字母组成")]), _vm._v(" "), _c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleShopType(key)
        }
      }
    }, [_c('div', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.text),
        expression: "item.text"
      }],
      attrs: {
        "type": "text",
        "disabled": "",
        "placeholder": "选择商户类型",
        "maxlength": "18"
      },
      domProps: {
        "value": (item.text)
      },
      on: {
        "click": function () {},
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "text", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('section', {
      staticClass: "label bb clearfix"
    }, [_vm._m(6, true), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "14px",
        "color": "#666666",
        "letter-spacing": "0",
        "line-height": "26px"
      }
    }, [_vm._v("热点证明（路由器背面铭牌照片）")]), _vm._v(" "), _c('div', {
      staticClass: "upload-img"
    }, [_c('wk-single-image-upload', {
      attrs: {
        "dest": "wifikey",
        "disabled": _vm.disabled
      },
      on: {
        "change": _vm.getHotspotEvidence
      },
      model: {
        value: (item.hotspotEvidence),
        callback: function($$v) {
          _vm.$set(item, "hotspotEvidence", $$v)
        },
        expression: "item.hotspotEvidence"
      }
    }, [_c('solt', {
      staticClass: "loading",
      attrs: {
        "name": "loading"
      }
    })], 1)], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "btn-body"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.formData.apInfoList.length > 1),
        expression: "formData.apInfoList.length > 1"
      }],
      staticClass: "add",
      on: {
        "click": function($event) {
          return _vm.handleWifi('del', key)
        }
      }
    }, [_c('img', {
      staticClass: "add-img",
      attrs: {
        "src": require("../assets/delete-wifi.png")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "delete-span"
    }, [_vm._v("删除热点")])]), _vm._v(" "), _c('div', {
      staticClass: "add",
      on: {
        "click": function($event) {
          return _vm.handleWifi('add', key)
        }
      }
    }, [_c('img', {
      staticClass: "add-img",
      attrs: {
        "src": require("../assets/add-wifi.png")
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "add-span"
    }, [_vm._v("添加热点")])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "des"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "upload-img"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "dest": "wifikey",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getBusinessLicense
    },
    model: {
      value: (_vm.formData.businessLicense),
      callback: function($$v) {
        _vm.$set(_vm.formData, "businessLicense", $$v)
      },
      expression: "formData.businessLicense"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "notice"
  }, [_vm._v("信息保护声明")]), _vm._v(" "), _c('div', {
    staticClass: "noticeInfo"
  }, [_vm._v("以上信息只供WiFi安全险登记及理赔用途，并不会用于其他商业用途。")])]), _vm._v(" "), _c('p', {
    staticClass: "protocol"
  }, [_c('van-checkbox', {
    attrs: {
      "icon-size": "16",
      "shape": "square",
      "checked-color": "#07c160"
    },
    on: {
      "change": _vm.changeCheck
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("\n        本人同意并接受\n        "), (_vm.protocol == 'protocol') ? _c('router-link', {
    attrs: {
      "to": "/new/protocol"
    },
    on: {
      "click": function($event) {
        return _vm.clickProtocol()
      }
    }
  }, [_vm._v("《WiFi万能钥匙商户热点安全保险协议》")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "errorMsg"
  }), _vm._v(" "), _c('p', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button btn",
    on: {
      "click": _vm.create
    }
  }, [_vm._v("参保安心上网")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 4
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright",
    staticStyle: {
      "padding-bottom": "12px"
    }
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), (_vm.showAlertModel) ? _c('div', {
    staticClass: "alert-model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("温馨提示")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.modelContent))]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "description",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n        客服电话："), _c('a', {
    attrs: {
      "href": "tel:4000358000"
    }
  }, [_vm._v("4000358000")]), _vm._v(" "), _c('span', {
    staticClass: "copy-qq",
    on: {
      "click": function($event) {
        return _vm.copyQq(4000358000)
      }
    }
  }, [_vm._v("复制")])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("我知道了")])])]) : _vm._e(), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "default-index": 2,
      "columns": _vm.columns
    },
    on: {
      "confirm": _vm.onConfirm,
      "change": _vm.onChange,
      "cancel": _vm.onCancel
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    staticStyle: {
      "display": "block"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "user_name"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("参保人姓名：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("身份证号：\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "color": "#FE2C54",
      "letter-spacing": "0",
      "line-height": "14px"
    }
  }, [_vm._v("＊")]), _vm._v("热点名称：\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("路由器MAC地址：\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("请选择商户类型：\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "demo_treelist_dummy"
    }
  }, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("请上传资质：\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {}, [_c('span', {
    staticClass: "xing_red"
  }, [_vm._v("＊")]), _vm._v("营业执照备案\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "description"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/tip.png")
    }
  }), _vm._v("如手机号码有更换，请联系官方客服\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d206e5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/createStore.vue
// module id = 836
// module chunks = 1